module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaBAMAAADKhlwxAAAAFVBMVEUAAAA0NDQ0NDQ0NDQ0NDQ1NTUzMzNhGZIpAAAABnRSTlMAnUrdhGVU/zKSAAAAtklEQVRYw+3WsQ3CQBBEUUMFkDgmogRiIhqgAhNc/yUgZKEfrKw/kkPvhGfP013gPU+dTuewOd98kdyXqWb+bL09LmXtNP5v1ydLpRH8EYDj9B2n7jhtxWvZcbqOU3WcpuOVVvwFHeAP6AB/P1kU3FNP1ziZwZOdDPCAvoI7vbDz5Iy/RkyvlZReOzEN7jStlHbcv2KfEE477pPNp+a+iezT3mnH/ZbyG3Dn7eo3d/5X0Ol0jpovJ2s1K+73OC8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/close_kon.png
// module id = 491
// module chunks = 39